import React from 'react';
import NonAuthLayout from '../pages/layout/NonAuthLayout';

interface ProtectRouteProps {
  // eslint-disable-next-line
  component: React.ComponentType<any>;
}

const NonAuthRoute: React.FC<ProtectRouteProps> = ({
  component: Component,
  ...props
}) => {
  return (
    <NonAuthLayout {...props}>
      <Component {...props} />
    </NonAuthLayout>
  );
};

export default NonAuthRoute;
